<template>
  <div>
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />

    <v-card>
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <v-card
          class="pa-2 overflow-y-auto"
          max-height="50vh"
          min-height="50vh"
          elevation="0"
        >
          <div class="text-uppercase text-center text-caption">
            <p p class="text-md-caption">
              <b
                >AGREEMENT REGARDING CONFIDENTIAL INFORMATION, OWNERSHIP OF
                INVENTIONS, NON-COMPETITION, <br />CLIENT NON-SOLICITATION AND
                EMPLOYEE NON-SOLICITATION COVENANTS, AND ACKNOWLEDGMENT OF
                AT-WILL EMPLOYMENT</b
              >
            </p>
          </div>
          <p class="text-md-caption">
            This Agreement regarding Confidential Information Covenant,
            Ownership of Inventions, Non-Competition, Client Non-Solicitation,
            and Employee Non-Solicitation Covenants and Acknowledgment of
            At-Will Employment (“Agreement”) is made and entered into by
            <b>
              <span class="text-decoration-underline text-uppercase">{{
                user.Name
              }}</span>
            </b>
            (“Employee”) in favor of {{ userCompany }}-UT LLC., a Utah
            corporation (“Company”). The Company and Employee are sometimes
            referred to collectively as the “Parties,” and each as a “Party.
          </p>
          <div class="text-uppercase text-center text-caption text-uppercase">
            <p p class="text-md-caption">
              <u>recital</u>
            </p>
          </div>

          <p class="text-md-caption">
            In consideration of the Company’s employment or continued employment
            of Employee, the payment of wages and other compensation and/or
            benefits by the Company to Employee, and other good and valuable
            consideration, the receipt, adequacy and legal sufficiency of which
            are hereby expressly acknowledged, the Parties agree and covenant as
            follows
          </p>

          <div>
            <p class="text-md-caption">
              1.
              <span class="ml-6"
                ><b><u>Definitions</u></b></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                a.
                <span class="ml-10"
                  ><b><u>Confidential Information</u></b></span
                ></span
              >
              “Confidential Information,” as used herein, means any present or
              future information belonging to the Company that pertains to its
              business, whether developed by Employee, other Company employees,
              or any of the Company’s contractors or agents, that is
              confidential or proprietary in nature, and that is not generally
              known in the public domain. Confidential Information includes,
              without limitation, information regarding the Company’s finances,
              financial condition, operations, business plans, business
              opportunities, purchasing activities, suppliers or potential
              suppliers, costs of materials, pricing, margins, sales, markets,
              marketing strategies, plans and ideas, clients, client lists,
              client agreements, client medical, financial or other information
              and documents, potential clients, employees, employee
              compensation, technical data, research, methodologies, services,
              software, developments, inventions, processes, formulas,
              technology, designs, drawings, Trade Secrets, Confidential
              Materials, Inventions, Employment Inventions, Intellectual
              Property, or any other confidential business information belonging
              to the Company that is disclosed to or obtained by Employee,
              directly or indirectly, whether in writing, orally, by observation
              or electronically (through email, computer disk, DVD, CD-ROM, or
              other electronic means
            </p>

            <p class="text-md-caption">
              <span class="ml-10">
                b.
                <span class="ml-10"
                  ><b><u>Trade Secrets.</u></b></span
                ></span
              >
              “Trade Secrets,” as used herein, means information, including a
              formula, pattern, compilation, program, device, method, technique,
              or process that(i) derives independent economic value, actual or
              potential, from not being generally known to and not being readily
              ascertainable by proper means by, other persons who can obtain
              economic value from its disclosure or use, and (ii) is the subject
              of efforts that are reasonable under the circumstances to maintain
              its secrecy
            </p>

            <p class="text-md-caption">
              <span class="ml-10">
                c.
                <span class="ml-10"
                  ><b><u>Confidential Materials.</u></b></span
                ></span
              >
              “Confidential Materials,” as used herein, means any tangible
              medium containing Confidential Information, including but not
              limited to paper, electronic or magnetic media, prototypes,
              products, and other materials.
            </p>

            <p class="text-md-caption">
              <span class="ml-10">
                d.
                <span class="ml-10"
                  ><b><u>Inventions.</u></b></span
                ></span
              >
              “Inventions,” as used herein, means any and all inventions,
              products, 2 formulations, discoveries, ideas, developments,
              improvements, technology, know how, products, devices, structures,
              equipment, processes, methods, techniques, formulas, trade
              secrets, texts, research, program, software, computer programs,
              source codes, data, designs, works of authorship, and or other
              materials, whether or not published, patented, copyrighted,
              registered or suitable therefor, and all intellectual property
              rights therein, to the extent they relate to the past, present,
              future, or anticipated business, research, development or trade of
              the Company.
            </p>

            <div class="text-md-caption">
              <span class="ml-10">
                e.
                <span class="ml-10"
                  ><b><u>Employment Inventions.</u></b></span
                ></span
              >
              “Employment Inventions,” as used herein, means any Invention or
              part thereof conceived, developed, reduced to practice, or created
              by Employee which is:
              <p class="ml-10">
                <span class="ml-13">
                  (1).
                  <span class="ml-10">
                    conceived, developed, reduced to practice, or created by the
                    Employee: (A) within the scope of the Employee’s employment
                    with the Company; (B) on the Company’s time; or (C) with the
                    aid, assistance, or use of any property, equipment,
                    facilities, supplies, resources, or Intellectual Property of
                    the Company;</span
                  ></span
                >
              </p>

              <p class="ml-10">
                <span class="ml-13">
                  (2).
                  <span class="ml-10">
                    the result of any work, services, or duties performed by
                    Employee for the Company;</span
                  ></span
                >
              </p>

              <p class="ml-10">
                <span class="ml-13">
                  (3).
                  <span class="ml-10">
                    related to the industry or trade of the Company; or</span
                  ></span
                >
              </p>

              <p class="ml-10">
                <span class="ml-13">
                  (4).
                  <span class="ml-10">
                    related to the current or demonstrably anticipated business,
                    research, or development of the Company.</span
                  ></span
                >
              </p>
            </div>

            <p class="text-md-caption">
              <span class="ml-10">
                f.
                <span class="ml-10"
                  ><b><u>Intellectual Property.</u></b></span
                ></span
              >
              “Intellectual Property,” as used herein, means any and all
              patents, copyrights, trademarks, service marks, trade secrets,
              know how, technology, ideas, or computer software belonging to the
              Company or relating to any Employment Invention.
            </p>
          </div>

          <div>
            <p class="text-md-caption text-uppercase">
              2.
              <span class="ml-6"
                ><b
                  ><u
                    >Covenant of Confidentiality, Non-disclosure and Authorized
                    Use of Confidential Information.</u
                  ></b
                ></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                a.
                <span class="ml-10"
                  >In connection with Employee’s employment with the Company,
                  Employee will receive or have access to Confidential
                  Information, including Trade Secrets, Confidential Materials,
                  Inventions, Employment Inventions, and Intellectual Property,
                  as those terms are defined in this Agreement.</span
                ></span
              >
            </p>

            <p class="text-md-caption">
              <span class="ml-10">
                b.
                <span class="ml-10"
                  >Employee acknowledges and agrees that all Confidential
                  Information shall remain the sole property of the
                  Company.</span
                ></span
              >
            </p>

            <p class="text-md-caption">
              <span class="ml-10">
                c.
                <span class="ml-10"
                  >Employee further acknowledges and agrees that all
                  Confidential Information belonging to the Company is valuable,
                  special and unique to its business, that the Company’s
                  business depends upon such Confidential Information, and that
                  the Company wishes to protect such Confidential Information by
                  keeping it confidential for the use and benefit of the
                  Company.</span
                ></span
              >
            </p>

            <p class="text-md-caption">
              <span class="ml-10">
                d.
                <span class="ml-10"
                  >Employee agrees that the Company’s Confidential Information
                  will be kept confidential and will not, without the prior
                  written consent of the Company, be disclosed by Employee
                  (whether directly or through some other person or entity), in
                  whole or in part, and will not be used by Employee, directly
                  or indirectly, for any purpose other than as expressly allowed
                  by the Company. In addition, Employee shall not use any
                  Confidential Information for Employee’s direct or indirect
                  benefit or for the direct or indirect benefit of any person or
                  entity other than the Company. Employee shall not aid,
                  encourage, or allow any other person or entity to use the
                  Confidential Information of the Company without
                  authorization.</span
                ></span
              >
            </p>

            <div class="text-md-caption">
              <span class="ml-10">
                e.
                <span class="ml-10"
                  >Employee further agrees to use reasonable and diligent
                  efforts to protect the confidentiality of the Company’s
                  Confidential Information. Employee specifically agrees:</span
                ></span
              >

              <p class="ml-10">
                <span class="ml-13">
                  (1).
                  <span class="ml-10">
                    to use the Company’s Confidential Information solely to
                    fulfill the duties of Employee’s employment with the
                    Company, and not otherwise to use such information for
                    Employee’s benefit or the benefit of others;</span
                  ></span
                >
              </p>

              <p class="ml-10">
                <span class="ml-13">
                  (2).
                  <span class="ml-10">
                    not to use, view, or access Confidential Information where
                    it can be seen or viewed by unauthorized persons, and not to
                    leave such information or materials where they can be seen
                    or accessed by unauthorized persons;</span
                  ></span
                >
              </p>

              <p class="ml-10">
                <span class="ml-13">
                  (3).
                  <span class="ml-10">
                    to notify the Company if Employee becomes aware of any loss,
                    misuse, wrongful disclosure, or other unauthorized access of
                    any Confidential Information by any person; and</span
                  ></span
                >
              </p>

              <p class="ml-10">
                <span class="ml-13">
                  (4).
                  <span class="ml-10">
                    to take all other reasonable steps necessary, or reasonably
                    requested by the Company, to safeguard the Confidential
                    Information from unauthorized disclosure or use.</span
                  ></span
                >
              </p>
            </div>

            <p class="text-md-caption">
              <span class="ml-10">
                f.
                <span class="ml-10"
                  >Employee’s duties of nondisclosure and confidentiality under
                  this Agreement govern Employee both during Employee’s
                  employment with the Company and following the termination of
                  the employment relationship. All obligations of
                  confidentiality shall continue for as long as is permitted by
                  law.</span
                ></span
              >
            </p>

            <p class="text-md-caption">
              <span class="ml-10">
                g.
                <span class="ml-10"
                  >Employee authorizes the Company to notify others, including
                  but not limited to the Company’s suppliers or the Employee’s
                  future employers, of the terms of this Agreement and the
                  Employee’s covenants and obligations hereunder</span
                ></span
              >
            </p>
          </div>

          <div>
            <p class="text-md-caption text-uppercase">
              3.
              <span class="ml-6"
                ><b
                  ><u
                    >Covenant to Maintain Confidentiality of Third Party Trade
                    Secrets.</u
                  ></b
                ></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                a.
                <span class="ml-10"
                  >Employee shall not disclose to the Company any trade secrets
                  or confidential information of any of Employee’s previous
                  employers or of any other party to whom Employee owes a duty
                  of confidentiality.</span
                ></span
              >
            </p>

            <p class="text-md-caption">
              <span class="ml-10">
                b.
                <span class="ml-10"
                  >Employee may be exposed to the trade secrets or confidential
                  information of third parties with whom the Company has a
                  business relationship, such as its clients or suppliers,
                  during the course of Employee’s employment with the Company.
                  Employee agrees to treat third party trade secrets and
                  confidential information in the same manner as Employee has
                  agreed to treat The Company’s Confidential Information under
                  this Agreement.
                </span></span
              >
            </p>
          </div>

          <div>
            <p class="text-md-caption text-uppercase">
              4.
              <span class="ml-6"
                ><b
                  ><u
                    >Covenant of Ownership and Disclosure of Developments.</u
                  ></b
                ></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                a.
                <span class="ml-10"
                  >Employee agrees to promptly disclose to the Company the
                  existence, use, and/or manner of operation of any and all
                  Employment Inventions as defined in the Definitions section of
                  this Agreement.</span
                ></span
              >
            </p>

            <p class="text-md-caption">
              <span class="ml-10">
                b.
                <span class="ml-10"
                  >Employee acknowledges and agrees that all Employment
                  Inventions are the sole and exclusive property of the Company.
                  Employee hereby assigns to the Company any and all copyrights,
                  patent rights, trade secrets, and other rights that Employee
                  may have in any Employment Invention. Employee agrees to take
                  all actions reasonably requested by the Company, both during
                  and after the term of Employee’s employment with the Company,
                  to assign to the Company, and to establish, perfect, exercise
                  or protect that company’s rights in any Employment Inventions
                  or title thereto, including without limitation, assisting in
                  obtaining or registering copyrights, patents, trademarks or
                  similar intellectual property rights and executing assignments
                  to the Company. If the Company is unable, because of
                  Employee’s mental or physical incapacity, geographic distance
                  or for any other reason, to obtain Employee’s approval or
                  signature on any document necessary or useful to claim,
                  secure, extend, protect or enforce any right in intellectual
                  property to which the applicable company has a reasonable
                  claim, then Employee hereby appoints the Company and its duly
                  authorized officers as Employee’s agent and attorney-in-fact
                  to act for Employee for the purpose of accomplishing such act
                  with the same legal force and effect as if executed by
                  Employee.
                </span></span
              >
            </p>
          </div>

          <div>
            <p class="text-md-caption">
              5.
              <span class="ml-6"
                ><b><u>Return of Information.</u></b> Upon the request of the
                Company, or upon the termination of Employee’s employment with
                the Company, for any reason, Employee shall deliver promptly
                (and in no event later than two (2) business days after such
                termination) to the Company all Confidential Information and
                other documents or materials belonging to the Company (including
                all copies thereof), and all other property belonging to the
                Company, which are in Employee’s possession, custody or
                control.</span
              >
            </p>
          </div>

          <div>
            <p class="text-md-caption">
              6.
              <span class="ml-6"
                ><b><u>Requests for Clarification.</u></b> In the event Employee
                is uncertain as to the meaning of any provision of this
                Agreement or its application to any particular information,
                document, item or activity, Employee will inquire in writing to
                Todd Thueson, the Company’s President, specifying any areas of
                uncertainty. The Company will respond in writing within a
                reasonable time and will endeavor to clarify any areas of
                uncertainty, including such things as whether it considers
                particular information or documents to be Confidential
                Information, and will endeavor to explain any provisions of this
                Agreement.</span
              >
            </p>
          </div>

          <div>
            <p class="text-md-caption">
              7.
              <span class="ml-6"
                ><b><u>Notice of Compelled Disclosure.</u></b> In the event that
                Employee or anyone to whom Employee transmits any Confidential
                Information pursuant to this Agreement (“Compelled Person”)
                becomes legally compelled (by oral questions, interrogatories,
                requests for information or documents, subpoena, civil
                investigative demand, or other similar judicial or other
                compulsory process) to disclose any of the Confidential
                Information, such Compelled Person will provide the Company with
                prompt written notice so that it may seek a protective order or
                other appropriate remedy to protect and preserve the
                confidentiality of such Confidential Information and/or waive
                compliance with the provisions of this Agreement. In the event
                that such a protective order or other remedy is not obtained, or
                compliance with the provisions of this Agreement is waived,
                Employee shall disclose or furnish only that portion of the
                Confidential Information that Employee is legally required to
                produce and will exercise Employee’s best efforts to obtain
                reliable assurance that the Confidential Information will be
                kept confidential to the greatest extent possible.</span
              >
            </p>
          </div>

          <div>
            <p class="text-md-caption">
              8.
              <span class="ml-6"
                ><b><u>Non-competition Covenant.</u></b> Employee agrees that
                during Employee’s employment with the Company and for a period
                of one (1) year following the termination of Employee’s
                employment with the Company (“Restricted Period”), with or
                without cause, Employee shall not directly or indirectly engage
                in competition with the Company, provide services to people with
                Autism and other developmental disabilities in a residential
                group home, daycare program or supported living program, and/or
                provide other products or services that are competitive with the
                goods and/or services provided by the Company (“Competitive
                Services”), in or within 100 miles of any county in which
                Employee provided services for the Company during the one year
                period prior to the termination of Employee’s employment with
                the Company (“Restricted Area”), without the express written
                consent of The Company. Employee further agrees that, during the
                Restricted Period, Employee will not directly or indirectly
                assist, perform services for, contract with, be employed by,
                establish or operate, or have an equity interest in any person
                or entity, whether as an employee, officer, director, owner,
                member, manager, agent, consultant, independent contractor, or
                otherwise, that engages in competition with the Company or that
                provides Competitive Services, in the Restricted Area, without
                the express written consent of the Company. Employee further
                agrees that, during the Restricted Period, Employee will not
                make any plans or take any action to prepare to provide
                Competitive Services, or to participate in any current or future
                business that provides or will provide Competitive Services,
                following the Restricted Period. Employee agrees that the
                Restricted Period set forth herein shall be extended for a
                period equal to the duration of any breach of this covenant by
                Employee.</span
              >
            </p>
          </div>

          <div>
            <p class="text-md-caption">
              9.
              <span class="ml-6"
                ><b><u>Client Non-Solicitation Covenant.</u></b> Employee
                promises, covenants and agrees that during the Restricted Period
                (as defined above), Employee shall not personally or on behalf
                of any other person or entity, or through any other person or
                entity, directly or indirectly, call on, solicit business from,
                sell to, or do business with any client of the Company who did
                business with the Company during the term of Employee’s
                employment with the Company, in connection with the providing of
                any Competitive Services. Employee agrees that the Restricted
                Period set forth herein shall be extended for a period equal to
                the duration of any breach of this covenant by Employee.</span
              >
            </p>
          </div>

          <div>
            <p class="text-md-caption">
              10.
              <span class="ml-6"
                ><b><u>Employee Non-Solicitation Covenant.</u></b> Employee
                promises, covenants and agrees that during the Restricted Period
                (as defined above), Employee shall not directly or indirectly
                (a) recruit, solicit or encourage, on Employee’s own behalf or
                on behalf of any other person, firm, partnership, company or
                entity, any person who is employed by the Company or was
                employed by the Company within three months of the termination
                of Employee’s employment with the Company (“Restricted
                Employee”) to become an employee or independent contractor of,
                or perform other work for, Employee, any other employer of
                Employee or any affiliated company, or any other person or
                entity; (b) employ or hire, offer to employ or hire, or
                facilitate or assist in the employing or hiring of, any
                Restricted Employee, to work for Employee, any other employer of
                Employee or any affiliated company, or any other person or
                entity; (c) ask, invite, induce or encourage any Restricted
                Employee to terminate his or her employment relationship with
                the Company or seek employment with another person or entity; or
                (d) otherwise interfere with or disrupt the employment or
                business relationship between the Company and any of its
                employees. Employee agrees that the Restricted Period set forth
                herein shall be extended for a period equal to the duration of
                any breach of this covenant by Employee.</span
              >
            </p>
          </div>

          <div>
            <p class="text-md-caption">
              11.
              <span class="ml-6"
                ><b><u>Remedies for Breach of the Covenants.</u></b> Employee
                recognizes that the Company’s business interest in maintaining
                the confidentiality of its Confidential Information, its rights
                in its Employee Inventions, its relationships and goodwill with
                its clients, and the stability of its work force, is so great
                that the remedy at law for Employee’s breach or threatened
                breach of the covenants contained in this Agreement may be an
                inadequate remedy. Employee agrees that, in the event of a
                breach or threatened breach by Employee of any of the covenants
                contained in this Agreement, a court of competent jurisdiction
                may issue a restraining order or an injunction against Employee,
                restraining or enjoining Employee from engaging in conduct or
                actions that violate the said covenant. In addition, the Company
                shall be entitled to any and all other remedies available to it
                at law or in equity, and no action by the Company in pursuing a
                given remedy shall constitute an election to forego other
                remedies.</span
              >
            </p>
          </div>
          <div>
            <p class="text-md-caption">
              12.
              <span class="ml-6"
                ><b><u>Reasonableness of Covenants.</u></b> Employee understands
                that the restrictions contained in the covenants set forth
                herein have been imposed only to the extent necessary to protect
                the Company from the loss of goodwill, from unfair competition,
                and to preserve the Company’s Confidential Information,
                including Trade Secrets. Each Party expressly acknowledges and
                agrees that the respective covenants and agreements contained
                herein are reasonable as to scope, time and geographical area,
                as applicable. Should any portion of this Agreement be
                determined to be unenforceable, that portion shall be severed or
                modified by a court of competent jurisdiction so as to permit
                enforcement of the remainder of the Agreement to the fullest
                extent possible. Any court enforcing the terms of this Agreement
                is specifically authorized to modify any non-competition and/or
                non-solicitation restriction contained in this Agreement in
                order to make it enforceable.</span
              >
            </p>
          </div>

          <div>
            <p class="text-md-caption">
              13.
              <span class="ml-6"
                ><b><u>At-Will Employment.</u></b> Employee’s employment with
                the Company is at-will, and may be terminated by Employee or by
                the Company at any time, with or without cause and with or
                without advance notice. Nothing in this Agreement alters the
                at-will status of Employee’s employment with the Company.</span
              >
            </p>
          </div>

          <div>
            <p class="text-md-caption">
              14.
              <span class="ml-6"
                ><b><u>General Provisions.</u></b></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                a.
                <span class="ml-10"
                  ><b><u>Governing Law.</u></b> This Agreement shall be governed
                  and construed in accordance with the laws of the State of Utah
                  applicable to agreements made and to be performed within the
                  State of Utah.</span
                ></span
              >
            </p>

            <p class="text-md-caption">
              <span class="ml-10">
                b.
                <span class="ml-10"
                  ><b><u>No Assignment or License.</u></b> Nothing contained in
                  this Agreement shall be construed as granting a license,
                  assignment, or other property interest to Employee in any
                  Confidential Information or other information or documents
                  disclosed by the Company to Employee. The provisions of this
                  Agreement are not assignable by Employee, and any attempt to
                  assign the covenant and/or obligations associated with this
                  Agreement shall be void <i>ab initio</i>.</span
                ></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                c.
                <span class="ml-10"
                  ><b><u>Survival.</u></b> The provisions of this Agreement
                  shall survive the termination of Employee’s employment with
                  the Company.</span
                ></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                d.
                <span class="ml-10"
                  ><b><u>Entire Agreement.</u></b> The provisions herein
                  constitute the entire agreement between the Parties with
                  respect to the subject matter hereof and supersede all prior
                  agreements, oral or written, and all other communications
                  relating to the subject matter hereof. No amendment or
                  modification of any provision of this Agreement will be
                  effective unless set forth in a document that purports to
                  amend this Agreement and is executed by all Parties.</span
                ></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                e.
                <span class="ml-10"
                  ><b><u>Waiver.</u></b> No waiver of any provision of this
                  Agreement shall be effective unless made in writing and signed
                  by the waiving party. The failure of either party to require
                  the performance of any term or obligation of this Agreement,
                  or the waiver by either party of any breach of this Agreement,
                  shall not prevent any subsequent enforcement of such term or
                  obligation or be deemed a waiver of any subsequent
                  breach.</span
                ></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                f.
                <span class="ml-10"
                  ><b><u>Attorneys’ Fees and Costs.</u></b
                  >In the event that either Party commences an action to enforce
                  the terms of this Agreement, or to seek damages or injunctive
                  relief for the alleged breach thereof, the prevailing party
                  shall be entitled to collect from the non-prevailing party
                  its, his or her reasonable attorneys’ fees and costs incurred
                  therein.</span
                ></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                g.
                <span class="ml-10"
                  ><b><u>Severability.</u></b> If any provision in this
                  Agreement shall be held by a court of competent jurisdiction
                  to be invalid, unenforceable, or void, such provision shall be
                  enforced to the fullest extent permitted by applicable law,
                  and the remainder of this Agreement shall remain in full force
                  and effect. In the event that the time period or scope of any
                  provision is declared by a court of competent jurisdiction to
                  exceed the maximum time period or scope that such court deems
                  enforceable, then such court shall reduce the time period or
                  scope to the maximum time period permitted by law.</span
                ></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                h.
                <span class="ml-10"
                  ><b><u>Submission to Jurisdiction and Venue.</u></b> Each
                  Party irrevocably consents and agrees that any action,
                  proceeding, or other litigation by or against the other Party
                  with respect to any claim or cause of action based upon or
                  arising out of or related to this Agreement shall be brought
                  and tried exclusively in the Fourth Judicial District Court of
                  Utah County, State of Utah, and any such legal action or
                  proceeding filed elsewhere may be removed to the aforesaid
                  court. By execution and delivery of the Agreement, each Party
                  accepts, generally and unconditionally, the exclusive
                  jurisdiction of the aforesaid court. Each Party hereby
                  irrevocably waives (a) any objection which it may now or
                  hereafter have to the laying of venue with respect any such
                  action, proceeding, or litigation arising out of or in
                  connection with this Agreement brought in the aforesaid court,
                  and (b) any right to stay or dismiss any such action,
                  proceeding, or litigation brought before the aforesaid court
                  on the basis of forum <i>non-conveniens.</i></span
                ></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                i.
                <span class="ml-10"
                  ><b><u>Waiver of Jury Trial.</u></b>
                  <span class="text-uppercase"
                    >TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, EACH
                    PARTY HEREBY WAIVES THE PARTY’S RIGHTS TO A TRIAL BY JURY
                    WITH RESPECT TO ANY CLAIM OR CAUSE OF ACTION BASED UPON OR
                    ARISING OUT OF OR RELATED TO THIS AGREEMENT IN ANY ACTION,
                    PROCEEDING OR OTHER LITIGATION OF ANY TYPE BROUGHT BY EITHER
                    PARTY AGAINST THE OTHER, WHETHER WITH RESPECT TO CONTRACT
                    CLAIMS, TORT CLAIMS, STATUTORY CLAIMS OR OTHERWISE. EACH
                    PARTY HEREBY AGREES THAT ANY SUCH CLAIM OR CAUSE OF ACTION
                    SHALL BE TRIED BY THE COURT WITHOUT A JURY. WITHOUT LIMITING
                    THE FORGOING, THE PARTIES FURTHER AGREE THAT THEIR
                    RESPECTIVE RIGHT TO A TRIAL BY JURY IS WAIVED BY OPERATION
                    OF THIS PARAGRAPH TO ANY ACTION, COUNTERCLAIM OR OTHER
                    PROCEEDING WHICH SEEKS, IN WHOLE OR IN PART, TO CHALLENGE
                    THE VALIDITY OR ENFORCEABILITY OF THIS AGREEMENT, OR ANY
                    PROVISION HEREOF. THIS WAIVER SHALL APPLY TO ANY SUBSEQUENT
                    AMENDMENTS, RENEWALS, SUPPLEMENTS, OR MODIFICATIONS TO THIS
                    AGREEMENT. EMPLOYEE ACKNOWLEDGEDS THAT THE FOREGOING WAIVER
                    CONSITUTES A MATERIAL CONSIDERATION FOR THE COMPANY IN
                    EXECUTING THIS AGREEMENT.</span
                  ></span
                ></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                j.
                <span class="ml-10"
                  ><b><u>Headings.</u></b> The heading used in this Agreement
                  are for convenience only and are not to be considered in
                  construing or interpreting this Agreement.</span
                ></span
              >
            </p>
            <p class="text-md-caption">
              <span class="ml-10">
                k.
                <span class="ml-10"
                  ><b><u>Counterparts.</u></b> This Agreement may be executed by
                  the Parties in separate counterparts, by facsimile, email, or
                  digital signature, and all of said counterparts taken together
                  shall be deemed to constitute one and the same agreement.
                  Signature pages may be detached from multiple separate
                  counterparts and attached to a single counterpart so that all
                  signatures are physically attached to the same document. A
                  facsimile, digital signature, or portable document format
                  (“pdf”) signature page shall constitute an original for
                  purposes hereof.</span
                ></span
              >
            </p>
          </div>
        </v-card>
        <div class="mt-3">
          <p class="text-caption">
            <b
              >IN WITNESS WHEREOF, the Parties have executed this Agreement as
              of the date set forth below.</b
            >
          </p>
        </div>
        <v-row>
          <v-col cols="12" md="6">
            <v-col cols="12" md="12">
              <div class="text-caption"><b>EMPLOYEE</b></div>
              <v-text-field
                v-model="item.employeeName"
                label="Employee's Name"
              ></v-text-field>

              <div style="position: relative">
                <v-text-field
                  label="Employee's Signature"
                  @click.stop="showSignaturePad = true"
                ></v-text-field>
                <v-img
                  width="150"
                  height="50"
                  :src="employeeSignature"
                  style="position:absolute;top:10px;right:150px;"
                ></v-img>
              </div>

              <v-menu
                ref="menu"
                v-model="employeeDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="item.dateSignedEmployee"
                    label="Dated"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="item.dateSignedEmployee"
                  @input="employeeDateMenu = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-col>
          <v-col cols="12" md="6">
            <v-col cols="12" md="12">
              <div class="text-caption"><b>{{ userCompany }}-UT LLC.</b></div>
              <v-text-field v-model="item.signedBy" label="By"> </v-text-field
              ><v-text-field v-model="item.signedIts" label="Its">
              </v-text-field>
              <v-menu
                ref="menu"
                v-model="companyDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="item.dateSignedCompany"
                    label="Dated"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="item.dateSignedCompany"
                  @input="companyDateMenu = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row align="center" justify="start">
              <v-card-actions>
                <v-btn color="" @click="prev">Prev</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>

          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>
<script>
/* eslint-disable */

import SignaturePad from "@/components/SignaturePad";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import download from "downloadjs";

export default {
  components: { SignaturePad },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      employeeDateMenu: false,
      companyDateMenu: false,
      userID: localStorage.getItem("userID"),
      item: {},
      employeeSignature: "",
      showSignaturePad: false,
      step: this.currentStep,
    };
  },

  created() {
    this.populateUserInfo();
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
    ...mapGetters("users", {
      user: "user",
      userCompany: "userCompany",
    }),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),

    signatureData(data) {
      this.employeeSignature = data;
    },

    next() {
      this.addItem();
      // this.generatePDF();
      this.$emit("clicked", this.step + 1);
    },

    prev() {
      this.$emit("clicked", this.step - 1);
    },

    async addItem() {
      try {
        const response = await this.addDocument({
          data: { ...this.item, Employee: this.user._id },
          pdfDocument: "non-compete-agreement",
        });
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {
      this.item.employeeName = this.user.Name;

      const response = await this.getDocuments(this.user._id);

      let documents = this.updateCase(
        response.data.document.Documents.NonCompeteAgreement
      );

      this.item = Object.assign(
        {},
        {
          ...documents,
          employeeName: response.data.document.Employee.Name,
          dateSignedEmployee: moment(documents.dateSignedEmployee).format("YYYY-MM-DD"),
          dateSignedCompany: moment(documents.dateSignedEmployee).format("YYYY-MM-DD"),
          employeeSignedDate: moment(documents.employeeSignedDate).format(
            "YYYY-MM-DD"
          ),
          companySignedDate: moment(documents.companySignedDate).format(
            "YYYY-MM-DD"
          ),
        }
      );
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "non-compete-agreement",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(pdfFile, "non-compete-agreement.pdf", "application/pdf");
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.v-stepper__content {
  top: 0;
  padding: 0 !important;
  flex: 1 0 auto;
  width: 100%;
}
.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
